import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormBuilder, FormControl } from '@angular/forms';
import { environment } from "src/environments/environment";
import { ErrorService } from "../error/err.service";
import { RESTAPI } from "../shared/stateapimanagement/apiwithoutstate";
import { RESTPROMISE } from "../shared/stateapimanagement/promisewithoutstate";
import { API_STATEMANAGEMENT } from "../shared/stateapimanagement/api-statemanagement";
import { Observable, Subject } from "rxjs";
import { SharedService } from '../services/shared.service';
import { ToastService } from '../shared/custom-overlay/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class DesignerService {
    commonData: any = this.sharedService.metaData.commonData;  
    studioMeta: any = JSON.parse(JSON.stringify(this.sharedService.metaData.studio)) // MetaData
    tabTitle:any =['Dashboards','Charts','Reports'];
    studioselectedIndex:number = 0;
    
    
    
    
    componentdestroyed: Subject<number> = new Subject();
    customerChangeLogggedOff: Subject<boolean> = new Subject();
    constructor(private fb:FormBuilder,
         public sharedService:SharedService,
         public http: HttpClient,
                 private errorservice: ErrorService,
                 private toastService: ToastService
        ) {
            this.sharedService.customerChanged_.subscribe(()=> this.resetUser());
          
            this.sharedService.$metaData.subscribe((metadata:any)=>{
              this.studioMeta = metadata.studio;
              // this.studioMeta["headers"]=["Total Dashboards","Published","Drafts","Data Sources"]
              this.commonData = metadata.commonData;
            
            })

            this.sharedService.userLoggedoff_.subscribe(()=>{
              this.resetdashboardlist();
              this.resetwidgetlist();
              // this.resetdashboardfrom();
            })
         }
    
    dashboardStat: any;
    dashboardpagenumber = 1;
    dashboardpagelength = 1;
    dashboardtablesearch = new FormControl('');
    dashboarditemperpage = new FormControl(this.studioMeta.paginationDefault.itemPerPage);
    // dashboardtableHeaders = this.studioMeta.dashboardTableHeaders
    // dashboardListOptions = this.studioMeta.dashboardListOptions

    dashboardtableHeaders =[
      "DASHBOARD NAME",
      "NO.OF CHARTS",
      "PUBLISHED DATE",
      "STATUS",
      "OWNER"
  ]

    dashboardListOptions =[
      {
          "disp": "Preview",
          "value": "preview",
          "permissionMode":"View"
      },
      {
          "disp": "Edit",
          "value": "edit",
          
      },
      {
          "disp": "Delete",
          "value": "delete",
          "permissionMode":"Delete"
      },
      {
        "disp" : "Publish",
        "value" : "publish",
        "permissionMode":"Edit"
      },
      {
        "disp" : "Unpublish",
        "value" : "unpublish",
        "permissionMode":"Edit"
      }
  ]
    dashboardList=[
    ]
    dashboardListGet=[]
    studioLandingchangeTab(event: number) {
      this.studioselectedIndex=event
    }
     resetUser(){
      this.resetdashboardlist();
      this.resetwidgetlist();
      // this.resetstudiofrom();
      // this.designerService.customerChangeLogggedOff.next(true);
    }

    resetdashboardlist(){

      this.studioselectedIndex = 0;
      this.dashboardStat = null;
      this.dashboardtablesearch.setValue('');
      this.dashboarditemperpage.setValue(this.studioMeta.paginationDefault.itemPerPage);


    }
      // Need to remove as per shared service
    headers = new HttpHeaders({ 'content-type': 'application/json','charset':'utf-8'});

    providedashboardstat = new RESTAPI(
        this.provideDashboardStat, 
        this.http, 
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        '/studio/dashboard/stat/get',
        'Dashboard',
        this.toastService
    )
    provideDashboardStat(requestdetails: any) {
        return this.http.post(environment.apiUrl + '/studio/dashboard/stat/get', requestdetails, { headers: this.headers })
    }

  
     providedashboardlist = new API_STATEMANAGEMENT(
           this.provideDashboardList, 
           this.http, 
           this.componentdestroyed.asObservable(), 
           this.customerChangeLogggedOff.asObservable()
       )
       provideDashboardList(pagination: any) {
        // return this.dashboardList
           return this.http.post(environment.apiUrl + '/studio/dashboard/list/get', pagination, { headers: this.headers })
       }

    //  widget - landing
   
    widgetpagenumber = 1;
    widgetpagelength = 1;
    widgettablesearch = new FormControl('');
    widgetitemperpage = new FormControl(this.studioMeta.paginationDefault.itemPerPage);
    // widgettableHeaders = this.studioMeta.widgetTableHeaders
    widgetListOptions = this.studioMeta.widgetListOptions
    widgetList=[
    
    ]
    widgetListGet=[]

    widgettableHeaders =[
      "CHART NAME",
      "CHART TITLE",
      "CHART TYPE",
      "DATA SOURCE",
      "TECHNOLOGY"
  ]
    

    resetwidgetlist(){

      this.studioselectedIndex = 0;
     
      this.widgettablesearch.setValue('');
      this.widgetitemperpage.setValue(this.studioMeta.paginationDefault.itemPerPage);


    }

    dashboardPublish(req){
      return this.http.post(environment.apiUrl + '/studio/dashboard/publish/post', req, { headers: this.headers })

    }
     

   
  
     providewidgetlist = new API_STATEMANAGEMENT(
           this.provideWidgetList, 
           this.http, 
           this.componentdestroyed.asObservable(), 
           this.customerChangeLogggedOff.asObservable()
       )
       provideWidgetList(pagination: any) {
        // return this.widgetList
           return this.http.post(environment.apiUrl + '/studio/widget/list/get', pagination, { headers: this.headers })
       }

       dashboardGet(dashboard_req: any) {
        return this.http.post(environment.apiUrl + '/studio/dashboard_builder/dashboard/get', JSON.stringify(dashboard_req), { headers: this.headers })
    }

    deleteDashboard(req){
      return this.http.post(environment.apiUrl + '/studio/dashboard/delete/post', req, { headers: this.headers })
    }

    deleteWidget(req){
      return this.http.post(environment.apiUrl + '/studio/widget/delete/post', req, { headers: this.headers })
    }

}
